import React from 'react';
import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  CircularProgress
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import useStyles from './styles';
import useActivityLogs from '@dyl/hooks/useActivityLogs';
import quickDateFormat from '@dyl/utils/quickDateFormat';

const HistoryLog = ({ isChangeMode }) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(1);
  const itemsPerPage = 7;

  // Fetch activity logs from API
  const { records, loading } = useActivityLogs('arc_template', 'arc_template', true, isChangeMode);

  const totalPages = Math.ceil(records.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const historyData = records.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    setPage((prev) => Math.max(1, prev - 1));
  };

  const handleNextPage = () => {
    setPage((prev) => Math.min(totalPages, prev + 1));
  };

  return (
    <Box className={classes.historyContainer}>
      <Typography gutterBottom className={`${classes.titleh1} ${classes.historyTitle}`}>
        History / log
      </Typography>
      <Typography variant="body1" gutterBottom className={`${classes.historyBody}`} sx={{ fontSize: '16px', fontWeight: 400, fontFamily: 'Roboto' }}>
        Below you can see a list of the previous templates used for the ARC Automarker. To change the active template, click on the 'Change' button next to the Active template above. In order to know the attributes of a template (.JSON file), the Admin needs to check with the ARC team. DO NOT change task templates when Live tests are in progress.
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer style={{ paddingRight: 0, maxWidth: '900px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeaderCell} style={{ width: '180px' }}>
                    Date
                  </TableCell>
                  <TableCell className={classes.tableHeaderCellWithPadding} style={{ width: '304px' }}>
                    User
                  </TableCell>
                  <TableCell className={classes.tableHeaderCellWithPadding} style={{ width: '200px' }}>
                    Template name
                  </TableCell>
                  <TableCell className={classes.tableHeaderCellWithPadding}>
                    Version
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {historyData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell className={classes.tableDataCell} style={{ width: '180px' }}>
                      {quickDateFormat(row.created_at)}
                    </TableCell>
                    <TableCell className={classes.tableDataCellWithPadding} style={{ width: '304px' }}>
                      {row.user_name}
                    </TableCell>
                    <TableCell className={classes.tableDataCellWithPadding} style={{ width: '200px' }}>
                      {row.template_name}
                    </TableCell>
                    <TableCell className={classes.tableDataCellWithPadding}>
                      {row.template_version}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <Box className={classes.paginationContainer} style={{ maxWidth: '100' }}>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
              <Box
                key={pageNum}
                className={classes.pageNumberBox}
                onClick={() => setPage(pageNum)}
                style={{
                  fontWeight: page === pageNum ? 'bold' : 'normal',
                  cursor: 'pointer',
                  border: page === pageNum ? '1px solid rgba(0, 0, 0, 0.23)' : 'none',
                  borderRadius: page === pageNum ? 4 : 0
                }}
              >
                {pageNum}
              </Box>
            ))}
            <IconButton
              onClick={handlePrevPage}
              disabled={page === 1}
              size="small"
            >
              <NavigateBeforeIcon />
            </IconButton>
            <IconButton
              onClick={handleNextPage}
              disabled={page === totalPages}
              size="small"
            >
              <NavigateNextIcon />
            </IconButton>
          </Box>
        </>
      )}
    </Box>
  );
};

export default HistoryLog;
